/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Gender_Not_Specified12Inputs */

const en__field__enum_gender_not_specified12 = /** @type {(inputs: _Field__Enum_Gender_Not_Specified12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not specified`)
};

const de__field__enum_gender_not_specified12 = /** @type {(inputs: _Field__Enum_Gender_Not_Specified12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Angabe`)
};

/**
* | output |
* | --- |
* | "Not specified" |
*
* @param {_Field__Enum_Gender_Not_Specified12Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_gender_not_specified12 = /** @type {((inputs?: _Field__Enum_Gender_Not_Specified12Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Gender_Not_Specified12Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_gender_not_specified12(inputs)
	return de__field__enum_gender_not_specified12(inputs)
});
export { _field__enum_gender_not_specified12 as "_field__enum_gender_NOT_SPECIFIED" }